import React, { useEffect } from "react";
import "./Component2.css";
import airport from "../img/airport.jpeg";
import business from "../img/Business.jpg";
import wedding from "../img/weddings.webp";
import dry from "../img/dry van.jpg";
import flatbed from "../img/flatbed.jpg";
import van from "../img/van.jpg";
import AOS from "aos";
import "aos/dist/aos.css";

const Component2 = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);
  return (
    <div className="div22" data-aos="fade-up">
      <div className="div2">
        <h1 className="h22">The Ultimate Luxury Limousine Service</h1>
        <p className="p22">
          we aim to provide our customers with fast and peaceful access to
          affordable luxury Limousine Service. We are well-known for our
          professionalism and high standard of service our customers expect when
          riding in a chauffeured vehicle. We encourage you to read the details
          below to expolre our services.
        </p>
      </div>
      <div className="grid_div">
        <div className="grid1">
          <img className="img1" src={airport} alt="" />
          <h5 className="h55">Airport Transportation</h5>
        </div>
        <div>
          <img className="img1" src={business} alt="" />
          <h5 className="h55">Business Travel</h5>
        </div>
        <div>
          <img className="img1" src={wedding} alt="" />
          <h5 className="h55">Weddings</h5>
        </div>
      </div>
      <div className="div2">
        <h1 className="h22">Trucking and Logistics Services</h1>
        <p className="p22">
          Logistics is the process of moving goods from one location to another,
          either in bulk or in small packages. It is one of the most important
          areas of a trucking company and if it is done improperly, it can have
          a big impact on the company as a whole.
        </p>
      </div>
      <div className="grid_div" data-aos="fade-up">
        <div>
          <img className="img1" src={dry} alt="" />
          <h5 className="h55">Dry Van</h5>
        </div>
        <div>
          <img className="img1" src={flatbed} alt="" />
          <h5 className="h55">Flatbed</h5>
        </div>
        <div>
          <img className="img1" src={van} alt="" />
          <h5 className="h55">Van</h5>
        </div>
      </div>
    </div>
  );
};

export default Component2;
